<template>
  <div>
    <h1>Purchase successful</h1>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {Button, TextButton, TextInput} from "@timenaut/timenaut-vue-common"
import ManagementNavigation from "@/components/ManagementNavigation.vue"

// TODO: Add download button

@Options({
  components: {
    TextInput,
    Button,
    TextButton,
    ManagementNavigation
  },
})
export default class SuccessPage extends Vue {
}
</script>
<style scoped>
.full-height {
  height: 100%;
  background-color: #E5E5E5;
  padding: 20px;
}

.signup {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
